module.exports = __webpack_public_path__ + "static/media/goat-eating-saag.0c21fe1e.gif";